import type { DeferredSpawn } from '../types';
import { registerWeapon, lookupWeapon, createProjectile } from './registry';
import { SMALL_CRATER } from '../terrain/crater-shapes';
import { random } from '../terrain/rng';

export const AIRBURST = registerWeapon({
  id: 'airburst',
  name: 'Airburst',
  description: 'Airbursts at apex into 2. Each child splits again. 7 total explosions.',
  tier: 'RARE',
  rarity: 'rare',
  projectileRadius: 10,
  projectileSpeed: 0.50,
  color: 0x44ff88,
  gravity: 0.15,
  bounces: 0,
  bounceEnergyRetention: 0.85,
  damage: 18,
  blastRadius: 55,
  knockbackMult: 0.05,
  knockbackRadius: 1.0,
  shakeIntensity: 3.5,
  particleScale: 0.8,
  craterShape: SMALL_CRATER,
  onTick(proj, state, _fx) {
    if (proj.generation >= 3) return null; // max 3 splits — final gen impacts normally

    proj.behaviorState.flightFrames = (proj.behaviorState.flightFrames || 0) + 1;
    const prevVy = proj.behaviorState.prevVy ?? proj.vy;
    proj.behaviorState.prevVy = proj.vy;

    // Detect apex (vy sign flip) OR fallback after 30 frames for weak/flat shots
    const atApex = prevVy < 0 && proj.vy >= 0;
    const fallback = proj.behaviorState.flightFrames >= 30;
    if ((atApex || fallback) && !proj.behaviorState.apexDetected) {
      proj.behaviorState.apexDetected = 1;
      const childWeapon = lookupWeapon('airburst');
      const spawns: DeferredSpawn[] = [];
      const hSpread = 3 + random() * 2; // horizontal-only spread
      for (let i = 0; i < 2; i++) {
        const dir = i === 0 ? -1 : 1;
        const child = createProjectile(
          childWeapon,
          proj.x, proj.y,
          proj.vx + dir * hSpread, // horizontal spread only
          proj.vy,                  // inherit vertical exactly
          proj.owner, state.frameCount, proj.generation + 1,
        );
        child.radius = proj.radius * 0.5; // 50% smaller each generation
        child.weapon = { ...child.weapon, gravity: child.weapon.gravity * 1.5 }; // 50% heavier
        spawns.push({
          spawnFrame: state.frameCount + 2,
          spawned: false,
          projectile: child,
        });
      }
      return { consume: true, spawns };
    }
    return null;
  },
});
